export default {
  de: {
    titles: {
      start_page: 'Startseite',
      purchase: 'Kaufen',
      posts: 'Küchenpost',
      post: 'Küchenpost',
      edit_post: 'Küchenpost bearbeiten',
      create_post: 'Küchenpost erstellen',
      articles: 'Artikel',
      create_article: 'Artikel erstellen',
      edit_article: 'Artikel bearbeiten',
      awards: 'Auszeichnung',
      create_award: 'Auszeichnung erstellen',
      edit_award: 'Auszeichnung bearbeiten',
      companies: 'Unternehmen',
      companies_ops: 'Unternehmen (OPS)',
      companies_crm: 'Unternehmen (CRM)',
      create_company: 'Unternehmen erstellen',
      draft_emails: 'Entwurf von E-Mails',
      create_draft_email: 'Erstellen Sie einen E-Mail-Entwurf',
      edit_draft_email: 'E-Mail-Entwurf bearbeiten',
      edit_company: 'Unternehmen bearbeiten',
      home: 'Herzlich willkommen bei mein-potpourri.de! Hier können Sie Ihre ' +
      'Bestellungen verwalten, spontane Einkäufe verbuchen und Potpourri' +
      ' mit uns gemeinsam gestalten.',
      posts_by: 'Küchenpost by',
      free_dishes: 'Freie Gerichte',
      free_dishes_for_order: 'Freie Gerichte zur Bestellung #',
      create_diet: 'Ernährungsform erstellen',
      edit_diet: 'Ernährungsform bearbeiten',
      diets: ' Ernährungsformen',
      ingredients: 'Zutaten',
      deadlines: 'Fristen',
      create_deadline: 'Frist erstellen',
      edit_deadline: 'Frist bearbeiten',
      delivery_areas: 'Liefergebiete',
      create_delivery_area: 'Liefergebiet erstellen',
      edit_delivery_area: 'Liefergebiet bearbeiten',
      generate_delivery_note: 'Lieferschein generieren',
      data: 'Daten',
      sales_per_week: 'Absatz je Woche',
      sales_per_week_price: 'Umsatz je Woche',
      sales_per_form: 'Absatz je Bestellformular',
      sales_per_form_price: 'Umsatz je Bestellformular',
      donations: 'Spenden',
      promocodes: 'Promo-Codes',
      create_promocode: 'Promo-Code erstellen',
      edit_promocode: 'Promo-Code bearbeiten',
      discount_codes: 'Gutscheincodes',
      create_discount_code: 'Gutscheincode erstellen',
      edit_discount_code: 'Gutscheincode bearbeiten',
      discount_codes_distribute: 'Gutschein-E-Mails versenden',
      planning: 'Mengenplanung',
      ratings: 'Bewertungen',
      donations_per_article: 'Spenden je Artikel',
      invoices: 'Rechnungen',
      invoice: 'Rechnung',
      tools: 'Werkzeuge',
      articles_nutrition: 'Ernährungsinformationen',
      tour_plans: 'Tourenplanungen',
      mailchimp: 'Mailchimp',
      critical_steps: 'Kritische Punkte',
      create_critical_step: 'Kritischen Punkt erstellen',
      edit_critical_step: 'Kritischer Punkt bearbeiten',
      working_steps: 'Arbeitsschritte',
      create_working_step: 'Arbeitsschritt erstellen',
      edit_working_step: 'Arbeitsschritt bearbeiten',
      resend_verification: 'Bestätigungs-Email erneut senden',
      sepa_send: 'SEPA einziehen',
      payments: 'Zahlungsauftragsdateien',
      work_times: 'Arbeitszeiten',
      work_time: 'Arbeitszeit',
      create_work_time: 'Neue Arbeitszeit',
      edit_work_time: 'Arbeitszeit bearbeiten',
      trip_report: 'Fahrbericht',
      trip_reports: 'Fahrberichte',
      create_trip_report: 'Neuer Fahrbericht',
      edit_trip_report: 'Fahrbericht bearbeiten',
      waiting_list: 'Benachrichtigungen an die Warteliste senden',
      company_price_category_prices: 'Preiskategorie Preise für Unternehmen',
      prices: 'Preise',
      company_types: 'Branchen',
      create_company_type: 'Branche erstellen',
      edit_company_type: 'Branche bearbeiten',
      journal_types: 'Journal-Typen',
      create_journal_type: 'Journal-Type erstellen',
      edit_journal_type: 'Journal-Type bearbeiten',
      journal_records: 'Journal',
      create_journal_record: 'Journaleintrag erstellen',
      edit_journal_record: 'Journaleintrag bearbeiten',
      postal_codes: 'Postleitzahlen Liefergebiet',
      create_postal_code: 'Postleitzahl erstellen',
      edit_postal_code: 'Postleitzahl bearbeiten',
      totals: 'Gesamteinnahmen',
      kpi: 'KPI report',
      topping_categories: 'Toping-Kategorien',
      create_topping_category: 'Toping-Kategorie erstellen',
      edit_topping_category: 'Toping-Kategorie bearbeiten',
      toppings: 'Toppings',
      create_topping: 'Topping erstellen',
      edit_topping: 'Topping bearbeiten',
    },
    fields: {
      name: 'Name',
      first_name: 'Vorname',
      last_name: 'Nachname',
      email: 'Email',
      password: 'Passwort',
      password_confirmation: 'Passwort Bestätigung',
      firm_name: 'Firmenname',
      gender: 'Geschlecht',
      description: 'Beschreibung',
      image: 'Bild (Das Bild wird nach dem Senden geändert)',
      article_name: 'Bezeichnung',
      ingredients: 'Zutaten (Label)',
      price_category: 'Preiskategorie',
      address: 'Adresse',
      contact_person: 'Ansprechpartner',
      contact_gender: 'Ansprechpartner Herr / Frau',
      contact_first_name: 'Ansprechpartner Vorname',
      contact_last_name: 'Ansprechpartner Nachname',
      contact_position: 'Ansprechpartner Funktion',
      phone_contacts: 'Telefonnummer Ansprechpartner',
      company_email: 'Email Ansprechpartner',
      company_description: 'Allgemeine Hinweise',
      comments: 'Kommentare',
      free_dishes: 'Freie Gerichte',
      comment: 'Kommentar',
      user_comment: 'Benutzerkommentar',
      discount: 'Rabatt',
      order: 'Bestellung',
      orders: 'Bestellungen',
      diets: ' Ernährungsformen',
      delivery_notes: 'Lieferhinweise (für Fahrer / Druck auf Lieferschein)',
      delivery_note_text: 'Einmalig dem Lieferschein hinzufügen',
      delivery_note_order_form: 'Bestellformular für Lieferschein',
      delivery_terms: 'Kundeninfo Bestellformular',
      deadline: 'Frist',
      delivery_area: 'Liefergebiet',
      user: 'Benutzer',
      code: 'Code',
      conversion: 'Umrechnung g',
      tax_percentage: 'MwSt.',
      start_date: 'Anfangsdatum',
      end_date: 'Endtermin',
      start_date_sepa: 'Von Rechnungsdatum',
      end_date_sepa: 'Bis Rechnungsdatum',
      iban: 'IBAN',
      name_of_account: 'Name des Kontoinhabers',
      sepa: 'SEPA',
      sepa_enabled: 'SEPA aktiviert',
      sepa_created_at: 'SEPA-Erstellungsdatum',
      sepa_comment: 'SEPA-Kommentar',
      nutritional_info: 'Ernährungsinformationen',
      driver: 'Fahrer',
      article: 'Artikel',
      warning: 'Achtung',
      max_batch_size: 'Max. Chargengröße',
      sex: {
        1: 'Herr',
        2: 'Frau',
      },
      tour_name: 'Tourname',
      optional: 'Wahlweise',
      collage_preview: 'Collage vorschau',
      collage_url: 'Collage URL',
      dob: 'Geburtstag',
      mobile_number: 'Handynummer',
      hourly_rate: 'Stundenlohn (brutto)',
      mileage_allowance: 'Kilometerpauschale',
      employment_type: 'Beschäftigungstyp',
      check_in_date_time: 'Check-In',
      check_out_date_time: 'Check-Out',
      paid: 'Bezahlt',
      employee: 'Mitarbeiter*in',
      date: 'Datum',
      start_location: 'Startpunkt',
      end_location: 'Endpunkt',
      distance: 'Entfernung',
      destination: 'Ziel(e)',
      delivery_areas: 'Liefergebiete',
      remarks: 'Bermerkungen',
      items: 'Anzahl Gläser/Stücke',
      status: 'Status',
      company_type: 'Branche',
      journal_type: 'Journal-Type',
      staff_on_site: 'Ø Mitarbeiter vor Ort',
      credit: 'Guthaben',
      kitchen_mail: 'Küchenpost',
      subject: 'Gegenstand',
      text: 'Text',
      attachments: 'Anhänge',
      select_draft_email: 'Wählen Sie den Entwurf einer E-Mail aus der Liste aus',
      sponsoring_home: 'Sponsoring nach Hause und Abholung',
      delivery_type: 'Lieferart',
      delivery: 'Lieferung',
      delivery_price: 'Lieferpreis',
      delivery_price_limit: 'Lieferpreislimit',
      house_number: 'Hausnummer',
      driven_km: 'Gefahrene Km',
      value: 'Wert',
      number_of_codes: 'Anzahl',
      weight: 'Produktgewicht in g',
      topping_categories: 'Topping-Kategorien',
      toppings_button_label: 'Titel der Beilagen',
      qty: 'Verbleibende Menge',
    },
    table_labels: {
      description: 'Beschreibung',
      quantity: 'Anzahl',
      total_price: 'Gesamtpreis',
      price: 'Preis',
      details: 'Einzelheiten',
      name: 'Name',
      email: 'Email',
      creator: 'Urheber',
      created_at: 'Erstellt am',
      image: 'Bild',
      actions: 'Aktionen',
      article_name: 'Bezeichnung',
      ingredients: 'Zutaten (Label)',
      price_category: 'Preiskategorie',
      quantity_of_users: 'Anzahl der Benutzer',
      firm_name: 'Firmenname',
      firm: 'Firma',
      free_dishes: 'Freie Gerichte',
      source: 'Quelle',
      type: 'Typ',
      updated_at: 'Zuletzt geändert',
      diets: ' Ernährungsformen',
      deadline: 'Frist',
      delivery_area: 'Liefergebiet',
      user: 'Benutzer',
      code: 'Code',
      expiration_date: 'Haltbarkeitsdatum',
      is_used: 'Wird eingesetzt',
      avg_rating: 'Ø Bewertung (alle)',
      number_of_ratings: 'Anzahl (alle)',
      rating: 'Bewertung',
      rating_comment: 'Kommentare und Tipps',
      start_date: 'Anfangsdatum',
      end_date: 'Endtermin',
      driver: 'Fahrer',
      amount_of_ratings: 'Anzahl Bewertungen',
      average_rating: 'Ø Bewertung',
      average_rating_last_order_form: 'Ø (letzte)',
      amount_of_ratings_last_order_form: 'Anzahl (letzte)',
      check_in_date_time: 'Check-In',
      check_out_date_time: 'Check-Out',
      check_out_time: 'Check-Out',
      paid: 'Bezahlt',
      date: 'Datum',
      distance: 'Entfernung',
      status: 'Status',
      company_type: 'Branche',
      journal_type: 'Journal-Type',
      staff_on_site: 'ØMA',
      contact_person: 'Ansprechpartner',
      contact_gender: 'Ansprechpartner Herr / Frau',
      contact_first_name: 'Ansprechpartner Vorname',
      contact_last_name: 'Ansprechpartner Nachname',
      contact_position: 'Ansprechpartner Funktion',
      wvl: 'WVL',
      phone_contacts: 'Telefon',
      company: 'Unternehmen',
      companies: 'Unternehmen',
      sponsoring_price: 'Sponsoring-Preis',
      credit: 'Guthaben',
      title: 'Titel',
      date_of_record: 'Aufnahmedatum',
      subject: 'Gegenstand',
      text: 'text',
      latest_order_form_date: 'Letzte Verwendung',
      latest_order_form_id: 'Letztes Bestellformular',
      latest_order_form_amount: 'Letzte Verkaufsmenge',
      all_avg_rating: 'Alle Ratings',
      latest_avg_rating: 'Letzte Ratings',
      delivery_type: 'Lieferart',
      value: 'Wert',
      topping_categories: 'Topping-Kategorien',
      is_active: 'Aktiv',
      qty: 'Verbleibende Menge',
    },
    placeholders: {
      name: 'Name eingeben',
      first_name: 'Vorname eingeben',
      last_name: 'Nachname eingeben',
      email: 'Email eingeben',
      firm_name: 'Suchen Sie den Firmennamen (mindestens 3 Buchstaben)',
      password: 'Passwort eingeben',
      password_confirmation: '',
      description: 'Beschreibung eingeben',
      search: 'Tippe um zu suchen',
      article_name: 'Bezeichnung eingeben',
      ingredients: 'Zutaten (Label) eingeben',
      price_category: 'Bitte wählen Sie die Preiskategorie',
      price_category_filter: 'Filtern nach Preiskategorie',
      address: 'Adresse eingeben',
      contact_person: 'Ansprechpartner eingeben',
      contact_gender: 'Ansprechpartner Herr / Frau eingeben',
      contact_first_name: 'Ansprechpartner Vorname eingeben',
      contact_last_name: 'Ansprechpartner Nachname eingeben',
      contact_position: 'Ansprechpartner Funktion eingeben',
      phone_contacts: 'Telefonnummer Ansprechpartner eingeben',
      company_email: 'Email Ansprechpartner eingeben',
      company_description: 'Allgemeine Hinweise eingeben',
      comments: 'Kommentare eingeben',
      comment: 'Kommentar eingeben',
      discount: 'Rabatt eingeben',
      delivery_notes: 'Lieferhinweise eingeben',
      delivery_note_text: 'Einmalig dem Lieferschein hinzufügen',
      delivery_note_order_form: 'Bestellformular für Lieferschein eingeben',
      delivery_terms: 'Kundeninfo Bestellformular',
      deadline: 'Frist eingeben',
      delivery_area: 'Liefergebiet eingeben',
      user: 'Benutzer eingeben',
      code: 'Code eingeben',
      tax_percentage: 'MwSt. eingeben',
      iban: 'IBAN eingeben',
      name_of_account: 'Name des Kontoinhabers eingeben',
      sepa: 'SEPA eingeben',
      sepa_created_at: 'SEPA-Erstellungsdatum eingeben',
      sepa_comment: 'SEPA-Kommentar eingeben',
      nutritional_info: 'Ernährungsinformationen eingeben',
      driver: 'Fahrer eingeben',
      tour_name: 'Tourname',
      collage_url: 'Collage URL',
      warning: 'Achtung eingeben',
      max_batch_size: 'Max. Chargengröße eingeben',
      dob: 'Geburtstag eingeben',
      mobile_number: 'Handynummer eingeben',
      hourly_rate: 'Stundenlohn (brutto) eingeben',
      mileage_allowance: 'Kilometerpauschale eingeben',
      employment_type: 'Beschäftigungstyp eingeben',
      check_in_date_time: 'Check-In eingeben',
      check_out_date_time: 'Check-Out eingeben',
      paid: 'Bezahlt eingeben',
      employee: 'Mitarbeiter*in',
      date: 'Datum',
      start_location: 'Start punkt',
      end_location: 'End punkt',
      distance: 'Entfernung',
      destination: 'Ziel(e)',
      delivery_areas: 'Liefergebiete',
      remarks: 'Bermerkungen',
      items: 'Anzahl Gläser/Stücke',
      status: 'Status eingeben',
      company_type: 'Branche eingeben',
      journal_type: 'Journal-Type eingeben',
      staff_on_site: 'Ø Mitarbeiter vor Ort eingeben',
      title: 'Titel eingeben',
      credit: 'Guthaben eingeben',
      subject: 'Geben Sie den Betreff der E-Mail ein',
      text: 'Geben Sie den E-Mail-Text ein',
      select_draft_email: 'Wählen Sie den Entwurf einer E-Mail aus der Liste aus',
      delivery_price: 'Lieferpreis eingeben',
      delivery_price_limit: 'Lieferpreislimit eingeben',
      value: 'Wert eingeben',
      number_of_codes: 'Anzahl',
    },
    actions: {
      stop: 'Abbrechen',
      continue: 'Weiter',
      submit: 'Speichern',
      clear: 'Entfernen',
      create_post: 'Küchenpost erstellen',
      details: 'Einzelheiten',
      load_more_posts: 'Weitere Posts zeigen',
      pre_order_now: 'Jetzt vorbestellen',
      update: 'Aktualisieren',
      generate: 'Generieren',
      show_all_ratings: 'Zeige alle Bewertungen',
      generate_invoices: 'Rechnungen erstellen',
      generate_sepa_with_paid: 'Trotzdem fortfahren',
      generate_sepa_without_paid: 'Fahren Sie ohne Initialisierung fort',
      send: 'Senden',
      send_email: 'E-Mail senden',
      create: 'Erstellen',
    },
    alerts: {
      delete_entity: 'Möchten Sie dieses {entity} wirklich löschen?',
      delete_company: 'Möchten Sie diesen Unternehmen wirklich löschen?',
      image: 'Bitte Bilddatei auswählen',
      email_sent: 'E-Mail gesendet.',
      email_sent_error: 'Fehler beim Senden der E-Mail.',
    },
    messages: {
      no_posts: 'Im Moment gibt es keine Küchenpfosten',
      no_active_forms: 'Momentan sind keine aktiven Bestellformulare vorhanden.',
      no_invoices: 'Es gibt keine Rechnungen',
      no_steps: 'Artikel hat noch keine Schritte',
      yes: 'Ja',
      no: 'Nein',
      guest: 'Gast',
      registered: 'Eingetragen',
      conversion: 'Wenn die Einheit der Zutat "g" ist, dann bitte 1.00 eintragen. In anderen Fällen bitte den Umrechnungsfaktor zu Gramm eintragen. ' +
      'Z.B. wiegen 100ml Milch 103g. Der Faktor für dieses Feld ist 1.03.',
      sepa_verified: 'SEPA verifiziert',
      sepa_activated: 'Aktiviert',
      sepa_deactivated: 'Deaktiviert',
      sepa_pending: 'Ausstehende Bestätigung',
      sepa_not_verified: 'SEPA nicht verifiziert',
      delivery_price: 'Bei einem Bestellwert unter {deliveryPriceLimit} EUR berechnen wir bei Lieferungen nach Hause {deliveryPrice} EUR Liefergebühr.',
    },
    search: {
      message: 'Die Suche funktioniert nach {entity}.',
      entities: {
        description: 'der Beschreibung',
        article_name: 'dem Bezeichnung',
        firm_name: 'dem Firmenname',
        contact_person: 'dem Ansprechpartner',
        name: 'dem Name',
        code: 'dem Code',
        subject: 'nach Betreff',
      },
    },
    crop: {
      drop: 'Datei zum Hochladen löschen',
      drag: 'Ziehen Sie ein Bild oder klicken Sie hier, um eine Datei auszuwählen',
    },
    name: 'Potpourri',
  },
};



// WEBPACK FOOTER //
// ./src/lang/de.js